<script setup lang="ts">
import CheckoutTimeline from "@/shop/components/checkout/CheckoutTimeline.vue"
import AuthorizationWizard from "@/shop/components/checkout/AuthorizationWizard.vue"
</script>

<template>
    <div class="container my-5">
        <div class="small text-muted mb-5 pb-3">Home / Warenkorb</div>

        <h2>Übersicht</h2>
        <div class="mb-3">
            <h1>Abholvollmacht</h1>
        </div>

        <CheckoutTimeline :step="4" />

        <AuthorizationWizard />
    </div>
</template>
